var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveyCardBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.085,
    height: 16.441,
    viewBox: "0 0 18.085 16.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74975",
    "data-name": "Group 74975",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73563",
    "data-name": "Path 73563",
    d: "M19.263,4H2.822A.822.822,0,0,0,2,4.822v14.8a.822.822,0,0,0,.822.822H19.263a.822.822,0,0,0,.822-.822V4.822A.822.822,0,0,0,19.263,4Zm-.28,15.212H3.136V9.949H18.983Zm0-10.238H3.136V5.142H18.983Z",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6613",
    "data-name": "Ellipse 6613",
    cx: 1.439,
    cy: 1.439,
    r: 1.439,
    transform: "translate(4.044 5.686)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74979",
    "data-name": "Group 74979",
    transform: "translate(0 0.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(4.055 10.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73553",
    "data-name": "Path 73553",
    d: "M3.458,3.424l.254.522.065.117.13.02.574.085-.411.4-.1.091.02.137.1.567L3.582,5.1l-.124-.065L3.334,5.1l-.509.267.1-.567.02-.137-.1-.091-.411-.4.574-.085.13-.02L3.2,3.946l.254-.522m0-.424a.137.137,0,0,0-.117.072l-.372.757-.835.117a.137.137,0,0,0-.072.228l.6.58-.137.835a.13.13,0,0,0,.124.15l.065-.013.743-.391.743.391.065.013a.13.13,0,0,0,.124-.15l-.137-.835.6-.58a.137.137,0,0,0-.072-.228l-.835-.117-.372-.757A.137.137,0,0,0,3.458,3Z",
    transform: "translate(-2.025 -3)",
    fill: "#185edf",
    stroke: "#185edf",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2-2",
    "data-name": "icons Q2",
    transform: "translate(7.754 10.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73553-2",
    "data-name": "Path 73553",
    d: "M3.458,3.424l.254.522.065.117.13.02.574.085-.411.4-.1.091.02.137.1.567L3.582,5.1l-.124-.065L3.334,5.1l-.509.267.1-.567.02-.137-.1-.091-.411-.4.574-.085.13-.02L3.2,3.946l.254-.522m0-.424a.137.137,0,0,0-.117.072l-.372.757-.835.117a.137.137,0,0,0-.072.228l.6.58-.137.835a.13.13,0,0,0,.124.15l.065-.013.743-.391.743.391.065.013a.13.13,0,0,0,.124-.15l-.137-.835.6-.58a.137.137,0,0,0-.072-.228l-.835-.117-.372-.757A.137.137,0,0,0,3.458,3Z",
    transform: "translate(-2.025 -3)",
    fill: "#185edf",
    stroke: "#185edf",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2-3",
    "data-name": "icons Q2",
    transform: "translate(11.454 10.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73553-3",
    "data-name": "Path 73553",
    d: "M3.458,3.424l.254.522.065.117.13.02.574.085-.411.4-.1.091.02.137.1.567L3.582,5.1l-.124-.065L3.334,5.1l-.509.267.1-.567.02-.137-.1-.091-.411-.4.574-.085.13-.02L3.2,3.946l.254-.522m0-.424a.137.137,0,0,0-.117.072l-.372.757-.835.117a.137.137,0,0,0-.072.228l.6.58-.137.835a.13.13,0,0,0,.124.15l.065-.013.743-.391.743.391.065.013a.13.13,0,0,0,.124-.15l-.137-.835.6-.58a.137.137,0,0,0-.072-.228l-.835-.117-.372-.757A.137.137,0,0,0,3.458,3Z",
    transform: "translate(-2.025 -3)",
    fill: "#185edf",
    stroke: "#185edf",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2-4",
    "data-name": "icons Q2",
    transform: "translate(15.153 10.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73553-4",
    "data-name": "Path 73553",
    d: "M3.458,3.424l.254.522.065.117.13.02.574.085-.411.4-.1.091.02.137.1.567L3.582,5.1l-.124-.065L3.334,5.1l-.509.267.1-.567.02-.137-.1-.091-.411-.4.574-.085.13-.02L3.2,3.946l.254-.522m0-.424a.137.137,0,0,0-.117.072l-.372.757-.835.117a.137.137,0,0,0-.072.228l.6.58-.137.835a.13.13,0,0,0,.124.15l.065-.013.743-.391.743.391.065.013a.13.13,0,0,0,.124-.15l-.137-.835.6-.58a.137.137,0,0,0-.072-.228l-.835-.117-.372-.757A.137.137,0,0,0,3.458,3Z",
    transform: "translate(-2.025 -3)",
    fill: "#185edf",
    stroke: "#185edf",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_73598",
    "data-name": "Path 73598",
    d: "M47.5,24.351a.611.611,0,0,1,0-1.222h9.743a.611.611,0,0,1,0,1.222Z",
    transform: "translate(-39.562 -16.615)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73599",
    "data-name": "Path 73599",
    d: "M47.664,24.2c-.425,0-.769-.239-.769-.535s.344-.535.769-.535H60.1c.425,0,.769.239.769.535s-.344.535-.769.535Z",
    transform: "translate(-42.85 -8.345)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73600",
    "data-name": "Path 73600",
    d: "M47.459,24.2a.535.535,0,1,1,0-1.069h9.135a.535.535,0,1,1,0,1.069Z",
    transform: "translate(-42.839 -6.29)",
    fill: "#185edf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyCardBlue);
export default __webpack_public_path__ + "static/media/Survey_card_Blue.dd1aa7456c5305e657352a9fcbfbcddb.svg";
export { ForwardRef as ReactComponent };